import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5","key":"svg-0"}],["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-1"}],["path",{"d":"M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5","key":"svg-2"}]]

const IconFileSpark = createReactComponent('outline', 'file-spark', 'FileSpark', __iconNode);

export default IconFileSpark;